/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {
  Component,
  ViewEncapsulation,
  Input,
  ElementRef,
  Renderer2,
} from '@angular/core';
import {CanColor, mixinColor} from '../../common-behaviors/color';

export type MdPseudoCheckboxState = 'unchecked' | 'checked' | 'indeterminate';
export class MdPseudoCheckboxBase {
/**
 * @param {?} _renderer
 * @param {?} _elementRef
 */
constructor(public _renderer: Renderer2,
public _elementRef: ElementRef) {}
}

function MdPseudoCheckboxBase_tsickle_Closure_declarations() {
/** @type {?} */
MdPseudoCheckboxBase.prototype._renderer;
/** @type {?} */
MdPseudoCheckboxBase.prototype._elementRef;
}

export const /** @type {?} */ _MdPseudoCheckboxBase = mixinColor(MdPseudoCheckboxBase, 'accent');
/**
 * Component that shows a simplified checkbox without including any kind of "real" checkbox.
 * Meant to be used when the checkbox is purely decorative and a large number of them will be
 * included, such as for the options in a multi-select. Uses no SVGs or complex animations.
 * 
 * Note that this component will be completely invisible to screen-reader users. This is *not*
 * interchangeable with <md-checkbox> and should *not* be used if the user would directly interact
 * with the checkbox. The pseudo-checkbox should only be used as an implementation detail of
 * more complex components that appropriately handle selected / checked state.
 * \@docs-private
 */
export class MdPseudoCheckbox extends _MdPseudoCheckboxBase implements CanColor {
/**
 * Display state of the checkbox.
 */
state: MdPseudoCheckboxState = 'unchecked';
/**
 * Whether the checkbox is disabled.
 */
disabled: boolean = false;
/**
 * @param {?} elementRef
 * @param {?} renderer
 */
constructor(elementRef: ElementRef, renderer: Renderer2) {
    super(renderer, elementRef);
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  encapsulation: ViewEncapsulation.None,
  selector: 'md-pseudo-checkbox, mat-pseudo-checkbox',
  styleUrls: ['pseudo-checkbox.css'],
  inputs: ['color'],
  template: '',
  host: {
    'class': 'mat-pseudo-checkbox',
    '[class.mat-pseudo-checkbox-indeterminate]': 'state === "indeterminate"',
    '[class.mat-pseudo-checkbox-checked]': 'state === "checked"',
    '[class.mat-pseudo-checkbox-disabled]': 'disabled',
  },
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'state': [{ type: Input },],
'disabled': [{ type: Input },],
};
}

function MdPseudoCheckbox_tsickle_Closure_declarations() {
/** @type {?} */
MdPseudoCheckbox.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MdPseudoCheckbox.ctorParameters;
/** @type {?} */
MdPseudoCheckbox.propDecorators;
/**
 * Display state of the checkbox.
 * @type {?}
 */
MdPseudoCheckbox.prototype.state;
/**
 * Whether the checkbox is disabled.
 * @type {?}
 */
MdPseudoCheckbox.prototype.disabled;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
